import { render } from "./Index.vue?vue&type=template&id=c7971c00&scoped=true"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"

import "./Index.vue?vue&type=style&index=0&id=c7971c00&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src3012/src/s3/00/frontend/admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c7971c00"]])

export default __exports__